import { ReactElement } from 'react'
import { useHistory } from 'react-router-dom'
import { useSelector, shallowEqual, useDispatch } from 'react-redux'
import { RootState } from '../../../../../redux/store'
import {
  getSelectedChapter,
  determineSynopsis,
  determineVideos
} from './helpers'
import { getSubjectLogo } from '../../../../../helpers'
import { Chapter } from '../../../../../redux/learn/type'
import { ListItem, SubHeader } from '../../../../../components'
import {
  SubjectWrapper,
  Videos,
  Materials,
  MaterialTitle,
  ListItemWrapper,
  MaterialWrapper
} from '../subcomponents'
import {
  setSelectedTopic,
  resetSelectedTopic,
  selectedMaterial
} from '../../../../../redux/learn/actions'
import ROUTES from '../../../../../const/routes'
import IconButton from '../../../../../components/IconButton'
import { capitalize } from '../../../../../helpers'
import strings from '../../../../../locale/en'
import pdfIcon from '../../../../../assets/pdf-icon.png'

const Topics = (): ReactElement => {
  const { chapters, selectedTopic } = useSelector(
    (state: RootState) => ({
      chapters: state.learn?.chapters,
      selectedTopic: state.learn?.chapters?.selectedTopic
    }),
    shallowEqual
  )
  const history = useHistory()
  const dispatch = useDispatch()
  const { subjectName = '', selectedChapter = '', list = [] } = chapters
  const selectdChapter = getSelectedChapter(list, selectedChapter) as Chapter
  const logo = getSubjectLogo({
    subject: subjectName
  })
  const listOfTopics = selectdChapter?.topicMaterialResponses
  const synopsis = selectedTopic?.materialList.filter(
    (material) => material.materialType !== 'video'
  )

  return (
    <SubjectWrapper id="container">
      <SubHeader
        title={selectdChapter?.courseName}
        handleBack={() => {
          history.goBack()
        }}
        logo={logo}
        subTitle={`${listOfTopics?.length} ${capitalize(strings.learn.topics)}`}
      />
      <ListItemWrapper>
        {listOfTopics?.map((topics, index) => {
          return (
            <ListItem
              id={`topics-list-${index}`}
              isSelected={
                selectedTopic?.topic?.courseName === topics?.topic?.courseName
              }
              title={topics?.topic?.courseName}
              key={`topic-${index}`}
              index={index}
              subTitle={`${determineVideos(topics).length} ${
                strings.learn.videos
              }, ${determineSynopsis(topics).length} ${strings.learn.synopsis}`}
              onSelect={() => {
                if (
                  selectedTopic &&
                  selectedTopic?.topic?.courseName === topics?.topic?.courseName
                ) {
                  dispatch(resetSelectedTopic())
                } else {
                  dispatch(setSelectedTopic(topics))
                }
              }}
            >
              <>
                <MaterialWrapper>
                  <MaterialTitle>Videos</MaterialTitle>

                  <Videos>
                    {selectedTopic?.materialList
                      .filter((material) => material.materialType === 'video')
                      .map((material, index) => {
                        return (
                          <IconButton
                            src={material?.filePath}
                            key={`material-${index}`}
                            title={material?.title}
                            onSubmit={() => {
                              dispatch(selectedMaterial(material))
                              history.push(ROUTES.MATERIAL)
                            }}
                          />
                        )
                      })}
                  </Videos>
                </MaterialWrapper>
                {!!synopsis?.length && (
                  <MaterialWrapper>
                    <MaterialTitle>Synopsis</MaterialTitle>

                    <Materials>
                      {synopsis.map((material, index) => {
                        return (
                          <IconButton
                            src={pdfIcon}
                            key={`material-${index}`}
                            title={material?.title}
                            onSubmit={() => {
                              window.open(material?.filePath)
                            }}
                          />
                        )
                      })}
                    </Materials>
                  </MaterialWrapper>
                )}
              </>
            </ListItem>
          )
        })}
      </ListItemWrapper>
    </SubjectWrapper>
  )
}

export default Topics
